<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["data-initialized", "data-id"];
import { computed, inject, provide } from "vue";
import { useMenuChannel } from "../composables/private/useMenuChannel";
import {
  MagicMenuInstanceId,
  MagicMenuViewId,
  MagicMenuContentId,
  MagicMenuChannelId,
  MagicMenuChannelActive
} from "../symbols";
import { useMenuState } from "../composables/private/useMenuState";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicMenuChannel",
  props: {
    id: { type: String, required: true },
    transition: { type: String, required: false }
  },
  setup(__props) {
    const instanceId = inject(MagicMenuInstanceId, void 0);
    const viewId = inject(MagicMenuViewId, void 0);
    const contentId = inject(MagicMenuContentId, void 0);
    if (!instanceId) {
      throw new Error("MagicMenuChannel must be nested inside MagicMenuProvider");
    }
    if (!viewId) {
      throw new Error("MagicMenuChannel must be nested inside MagicMenuView");
    }
    if (!__props.id) {
      throw new Error("MagicMenuChannel requires an id");
    }
    const { initializeState } = useMenuState(instanceId);
    const state = initializeState();
    if (!contentId) {
      if (state.options.debug) {
        console.warn("MagicMenuChannel is not nested inside MagicMenuContent");
      }
    }
    const mappedId = computed(() => `magic-menu-channel-${__props.id}`);
    const mappedTransition = computed(
      () => __props.transition ?? state.options.transition.channel
    );
    const { initializeChannel } = useMenuChannel({
      instanceId,
      viewId
    });
    const channel = initializeChannel({
      id: mappedId.value
    });
    const mappedActive = computed(() => channel.active);
    provide(MagicMenuChannelId, mappedId.value);
    provide(MagicMenuChannelActive, mappedActive);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Transition, { name: mappedTransition.value }, {
        default: _withCtx(() => [
          _unref(channel).active ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "magic-menu-channel",
            "data-initialized": _unref(state).active,
            "data-id": mappedId.value
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 8, _hoisted_1)) : _createCommentVNode("v-if", true)
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["name"]);
    };
  }
});
</script>

<style>
.magic-menu-channel-enter-active {
  animation: fade-in 225ms ease;
  &[data-initialized='true'] {
    position: absolute;
  }
}

.magic-menu-channel-leave-active {
  animation: fade-out 225ms ease;
  &[data-initialized='true'] {
    position: absolute;
  }
}
</style>
